module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-header', {
    staticStyle: {
      "background-color": "#2b3033"
    },
    attrs: {
      "left-options": {
        backText: ""
      }
    }
  }, [_vm._v("\n      目录脚本执行权限管理\n    ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-group-list domain-list"
  }, [_c('div', {
    staticClass: "form-group margin-bottom-20"
  }, [_c('div', {
    staticClass: "form-group-item"
  }, [_c('span', {
    staticClass: "form-label"
  }, [_vm._v("\n\t\t\t\t\t\t执行权限\n\t\t\t\t\t")]), _vm._v(" "), _c('inline-x-switch', {
    staticStyle: {
      "margin-top": "0.12rem"
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group-item"
  }, [_c('x-input', {
    staticStyle: {
      "padding": "0"
    },
    attrs: {
      "label-width": "8em",
      "title": "目录列表\\web\\",
      "placeholder": "请输入文件夹路径"
    },
    model: {
      value: (_vm.dirPathInput),
      callback: function($$v) {
        _vm.dirPathInput = $$v
      },
      expression: "dirPathInput"
    }
  })], 1)])]), _vm._v(" "), _c('x-button', {
    staticStyle: {
      "background-color": "#00aaff",
      "color": "#fff",
      "margin-top": ".2rem",
      "width": "97%"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submit($event)
      }
    }
  }, [_vm._v("确定")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mui-inner-wrap"
  }, [_c('div', {
    staticClass: "alert-warn margin-bottom-20 domain-list"
  }, [_c('p', {
    staticClass: "line-left-dot"
  }, [_vm._v("通过该功能，您可以对指定的文件夹取消ASP/PHP/CGI/ASP.Net权限。 （对网站安全具有重要意义，例如防止黑客上传ASP木马到图片或头像目录去运行）")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c62552a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/console/hostoperate/actauth.vue
// module id = Pvmo
// module chunks = 1